import { PatientInfo } from 'src/ts';
import { chunkArray } from '../chunk-array';

export const chunkPatientsIds = (patientsList: PatientInfo[]) => {
  const patientsIds = patientsList.map(patient => patient.id);
  const chunkedPatientsIds = chunkArray(patientsIds, 100);
  return chunkedPatientsIds;
};
